<template>
  <cst-page-template :hide-menu="true">
    <header-menu />
    <div class="instructions-page">
      <div class="instructions-page__header">
        <h1>Instructies</h1>
      </div>
      <manual-instructions-section @on-error="$emit('onError')" />
      <video-instructions-section @on-error="$emit('onError')" />
    </div>
  </cst-page-template>
</template>

<script>
import CstPageTemplate from '@/templates/CstPageTemplate.vue'
import HeaderMenu from '@/components/generic/presentational/molecules/headerMenu/HeaderMenu.vue'
import VideoInstructionsSection from './VideoInstructionsSection.vue'
import ManualInstructionsSection from './ManualInstructionsSection.vue'

export default {
  components: { CstPageTemplate, HeaderMenu, VideoInstructionsSection, ManualInstructionsSection },
  emits: ['onError'],
  watch: {
    '$route.hash'(hash) {
      this.scrollToHash(hash)
    },
  },
  mounted() {
    this.$nextTick(() => this.scrollToHash(this.$route.hash))
  },
  methods: {
    scrollToHash(hash) {
      if (!hash) return
      const el = document.querySelector(hash)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    },
  },
}
</script>

<style lang="scss" scoped>
.instructions-page {
  width: 100%;
  padding: 0 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;

  &__header {
    padding-top: 1.5rem;

    h1 {
      margin: 0;
      font-size: 1.75rem;
      color: $gray-darker;
    }
  }
}
</style>
